module.exports = __webpack_public_path__ + "assets/img/link_img_a.de3ec416.png";